<template>
  <div>
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">View User</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="topFilter">
      <div class="container lg">
        <form @submit.prevent="submit" class="form-horizontal">
          <div class="form-group">
            <div class="col-xs-8">
              <input
                id="email"
                type="text"
                v-model="email"
                class="form-control filter"
              />
            </div>
            <div class="col-xs-4">
              <button
                v-if="loading"
                class="btn btn-default btn-block"
                disabled=" "
              >
                <i class="fad fa-spinner-third fa-spin m-r-xs"></i>Loading
              </button>
              <button
                v-else-if="!email"
                class="btn btn-default btn-block"
                disabled=" "
              >
                Submit
              </button>
              <button v-else class="btn btn-accent btn-block text-accent">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="loader-example" v-if="!ready">
      <div class="loader-bar"></div>
    </div>
    <div class="container-center lg animated fadeIn" v-else>
      <div v-if="user">
        <div class="col-sm-6">
          <div class="view-header">
            <div class="header-icon">
              <i class="fad fa-user-astronaut pe-7s-user"></i>
            </div>
            <div class="header-title">
              <h4 class="m-b-xs">{{ user.email }}</h4>
              <p>{{ user.level }} : {{ user._id }}</p>
              <p>Activate : {{ user.active }}</p>
              <p>CreatedAt : {{ timeformatt(user.createdAt) }}</p>
              <p>
                Refer ID :
                <span
                  class="text-accent pointer"
                  v-on:click="gotorefer(user.refer_id)"
                  >{{ user.refer_id }}</span
                >
              </p>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <span>
            <router-link
              v-bind:to="'/usertx/' + user.email"
              class="btn btn-accent btn-block"
            >
              <i class="fad fa-file-invoice-dollar"></i> Txs
            </router-link>
            <router-link
              v-bind:to="'/addmoney/' + user.email"
              class="btn btn-info btn-block"
            >
              <i class="fas fa-hand-holding-usd"></i> Add money
            </router-link>
            <router-link
              v-bind:to="'/reset2fa/' + user.email"
              class="btn btn-danger btn-block"
            >
              <i class="fab fa-google"></i> Reset 2FA
            </router-link>
          </span>
        </div>

        <div class="col-sm-12">
          <h3 class="text-grad">User Funds</h3>
          <div class="panel panel-b-dark">
            <div class="panel-body">
              <div class="text-center m-t-xs">
                <div v-if="getCoins['BTC']">
                  Equity Value(BTC)
                  <h3 class="m-t-xs">
                    {{ (total_usd / getCoins["BTC"].last_price).toFixed(8) }}
                    BTC
                    <br />
                    <small>≈ $ {{ total_usd.toFixed(2) }}</small>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-condensed text-right">
            <thead>
              <tr class="font-bold c-white">
                <td>Currency</td>
                <td>Balance</td>
                <td class="hidden-xs">In orders</td>
                <td>In staking</td>
                <td class="hidden-xs">Available</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="b in funds" v-bind:key="b.id">
                <template v-if="b.balance != 0">
                  <td>{{ b.coin }}</td>
                  <td>{{ fixed4(b.balance) }}</td>
                  <td class="hidden-xs">
                    {{ fixed4(b.inorder) }}
                  </td>
                  <td>
                    {{ fixed4(b.instaking) }}
                  </td>
                  <td class="hidden-xs">
                    {{ fixed4(b.available) }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-sm-12">
          <h3 class="text-grad">Summary</h3>
          <div class="panel panel-filled">
            <div class="panel-body">
              <div class="col-sm-6" v-for="b in invests" v-bind:key="b.id">
                <div class="user-content">
                  <span v-bind:class="' label ' + b._id.label">
                    {{ b._id.type }}
                    ({{ b.count.toLocaleString() }})</span
                  >

                  <span class="pull-right"
                    ><span class="c-white font-bold m-r-sm">{{
                      b.amount.toFixed(8) / 1
                    }}</span>
                    {{ b._id.currency }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <h3 class="text-grad">Wallet</h3>
          <div class="panel panel-filled">
            <div class="panel-body">
              <div class="col-sm-6" v-for="w in wallet" v-bind:key="w.id">
                <div class="user-content">
                  <p>
                    [{{ w.currency }}]: <br /><addresslink
                      :currency="w.currency"
                      :address="w.address"
                    ></addresslink>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h3 class="text-grad">Deposit Summary</h3>
          <div class="panel panel-filled">
            <div class="panel-body">
              <div v-for="d in deposit" v-bind:key="d.id">
                <div class="user-content">
                  <span v-bind:class="'label ' + d.label">{{ d.status }}</span>
                  {{ d.createdAt }}

                  <span class="c-white font-bold m-r-sm">{{
                    d.amount.toFixed(8) / 1
                  }}</span>
                  {{ d.currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h3 class="text-grad">Withdrawal Summary</h3>
          <div class="panel panel-filled">
            <div class="panel-body">
              <div v-for="d in withdraw" v-bind:key="d.id">
                <div class="user-content">
                  <span v-bind:class="'label ' + d.label">{{ d.status }}</span>
                  {{ d.createdAt }}

                  <span class="c-white font-bold m-r-sm">{{
                    (d.amount / 1).toFixed(8) / 1
                  }}</span>
                  {{ d.currency }}
                  <br />
                  <addresslink
                    :currency="d.currency"
                    :address="d.address"
                  ></addresslink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row"></div>
      </div>
      <div v-else>
        <div class="container-center lg loader-example text-center">
          <i class="fad fa-search fa-4x"></i>
          <h4>Enter Email to search</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import admin from "@/api/admin";
import func from "@/widgets/func";
import nativeToast from "native-toast";
import moment from "moment";
import label from "@/widgets/label";
import { mapGetters, mapActions } from "vuex";

import addresslink from "@/components/addresslink";

export default {
  components: {
    addresslink,
  },
  data() {
    return {
      total_usd: 0,
      email: this.$route.params.email || null,
      ready: false,
      loading: false,
      filter: "",
      user: null,
      deposit: [],
      invests: [],
      funds: [],
      wallet: [],
    };
  },
  computed: mapGetters(["getInvest", "getCoins"]),
  methods: {
    ...mapActions(["fetchInvest"]),
    timeformatt(time) {
      return moment(time).format("YYYY-MM-DD, HH:mm:ss");
    },
    fixed(a) {
      return func.fixed(a);
    },
    fixed4(a) {
      return func.fixed8(a);
    },
    async getdata() {
      await admin
        .user({ email: this.email })
        .then((res) => {
          this.ready = true;
          this.loading = false;

          this.user = res.data.user;

          this.deposit = [];
          res.data.deposit.forEach((e) => {
            var a = label.type(e.status);
            e.label = a.label;

            e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

            this.deposit.push(e);
          });

          this.withdraw = [];
          res.data.withdraw.forEach((e) => {
            var a = label.type(e.status);
            e.label = a.label;

            e.createdAt = moment(e.createdAt).format("YYYY-MM-DD, HH:mm:ss");

            this.withdraw.push(e);
          });

          this.invests = [];
          res.data.invests.forEach((e) => {
            var a = label.type(e._id.type);
            e._id.label = a.label;

            this.invests.push(e);
          });

          this.funds = res.data.funds;
          this.wallet = res.data.wallet;
        })
        .catch((error) => {
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error",
          });
        });
    },
    async gotorefer(refer) {
      this.email = refer;
      this.loading = true;
      this.history_rows = [];
      this.getdata();
    },
    async submit() {
      if (this.email) {
        this.loading = true;
        this.history_rows = [];
        this.getdata();
      } else {
        this.loading = false;
        nativeToast({
          message: "email is require",
          position: "top",
          timeout: 3000,
          type: "error",
        });
      }
    },
    caltotal() {
      var total = 0;
      for (let [coin, value] of Object.entries(this.funds)) {
        if (this.getCoins[coin]) {
          total = total + value.balance * this.getCoins[coin].last_price;
        }
      }
      this.total_usd = total;
    },
  },
  created() {
    this.fetchInvest();
    if (this.email) {
      this.getdata();
    } else {
      this.ready = true;
    }
  },
  updated() {
    this.caltotal();
  },
};
</script>

<style scoped>
.container-center {
  margin-top: 100px;
  padding: 0 0 150px 0;
}
.loader-example {
  margin-top: 200px;
}
.coin {
  width: 32px;
}
</style>
